var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 125",
    fillRule: "evenodd",
    clipRule: "evenodd",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.83 39.06L53.9 30.61a7.45 7.45 0 00-7.8 0l-13.94 8.44v27.96c0 1.88 1.61 3.49 3.49 3.49h5.72V55.63c0-2.75 2.25-5 5-5h7.25c2.76 0 5 2.24 5 5V70.5h5.73c1.89 0 3.48-1.6 3.48-3.49V39.06zM44.71 70.5h10.58V55.63c0-.92-.75-1.67-1.67-1.67h-7.25c-.91 0-1.66.75-1.66 1.67V70.5zm26.46-29.42v25.93c0 3.71-3.11 6.82-6.82 6.82h-28.7c-3.71 0-6.82-3.1-6.82-6.82V41.07l-3.79 2.29c-1.87 1.12-3.57-1.72-1.71-2.84l21.03-12.74c3.49-2.14 7.79-2.13 11.27-.01l21.04 12.77c1.86 1.12.16 3.96-1.72 2.83l-3.78-2.29zM25.11 12.53c-1.81 1.22-3.66-1.54-1.85-2.76 8-5.36 17.11-8.1 26.74-8.1 26.7 0 48.33 21.64 48.33 48.33 0 26.69-21.63 48.33-48.33 48.33C23.31 98.33 1.67 76.69 1.67 50c0-9.62 2.87-19.04 8.25-27.02 1.23-1.81 3.99.05 2.76 1.86C7.64 32.31 5 40.99 5 50c0 24.85 20.15 45 45 45s45-20.15 45-45S74.85 5 50 5c-8.95 0-17.44 2.55-24.89 7.53z",
    fillRule: "nonzero"
  })));
}

export default SvgHomeIcon;